import { AppList, baseRealEstateUrl, getUrlWithUtmQueryString, Button} from '@capcenter/shared';
import { useRecoilValue } from 'recoil';
import ScheduleATour from '../ScheduleATour/ScheduleATour';
import React, { useEffect } from 'react';
import * as AppState from '../../../AppState';
import { OpenHouseEntry } from '../../../interfaces/interfaces';
import { OpenHousesList } from '../OpenHouse/OpenHousesList';

const CallsToActionHighlight = (props: { address: any, applyNowUrl: string, calculatorUrl: string, price: number, closeDate: Date, openHouses?: OpenHouseEntry[]}) => {
	return props.closeDate ? (
		<SellCallsToAction address={props.address} applyNowUrl={props.applyNowUrl} price={props.price}/>
	) : (
		<BuyCallsToAction address={props.address} applyNowUrl={props.applyNowUrl} calculatorUrl={props.calculatorUrl} price={props.price} openHouses={props.openHouses}/>
	);
};

const BuyCallsToAction = (props: { address: any, applyNowUrl: string, calculatorUrl: string, price: number, openHouses?: OpenHouseEntry[]}) => {
	const userOnMobile = useRecoilValue(AppState.gsIsMobile);
	const [viewHeight, setViewHeight] = React.useState<number>(0);

	useEffect(()=>{
		setViewHeight(Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0));
		window.addEventListener('resize', ()=>{setViewHeight(Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0));});
	}, []);

	return userOnMobile ? (
		<>
			<div className="d-flex w-100 py-1">
				<div className="px-1" style={{ width: '49%' }}>
					<Button
						variant="filled"
						label="Request Tour Time"
						icon="far fa-house-user"
						className="w-100 fw-bold mt-1"
						size="lg"
						resetText
						newTab
						href={getUrlWithUtmQueryString(encodeURI(`${baseRealEstateUrl}${AppList.scheduleTour.url}?listingaddressfortour=${props.address}&purchasePrice=${props.price}`))}
					/>
				</div>
				<div className="px-1" style={{ width: '49%' }}>
					<Button
						variant="filled"
						label="Get Pre-approved"
						icon="far fa-check"
						className="w-100 fw-bold mt-1"
						size="lg"
						resetText
						newTab
						href={`${props.applyNowUrl}`}
					/>
				</div>
			</div>
		</>
	) : (
  <div className='h-100'>
    {props.openHouses && <OpenHousesList OpenHouses={props.openHouses} address={props.address}/>}
    <div className="shadow border-radius mt-4 cc-bg--white-100 w-100 pb-3 pt-2 position-sticky" style={{top: '48px'}}>
      <div className="w-100 px-4">
        { viewHeight >= 700 ?
          <>
            <ScheduleATour
              address={props.address}
              price={props.price}
            />
            <span className='w-100 row mt-1' style={{ marginLeft: '1px', marginBottom: '-1em' }}>
              <div className='col-sm-5' style={{
                marginTop: '1em',
                height: '1px',
                borderStyle: 'inset',
                borderWidth: '1px'
              }}>
              </div>
              <p className="col-sm-2" style={{
                textAlign: 'center',
                marginTop: '0.5em'
              }}>OR</p>
              <div className="col-sm-5" style={{
                height: '1px',
                marginTop: '1em',
                borderStyle: 'inset',
                borderWidth: '1px'
              }}>

              </div>
            </span>
          </>
          :
          <Button
            variant="filled"
            label="Request Tour"
            icon="far fa-house-user"
            className="w-100 fw-bold mt-1"
            size="lg"
            resetText
            newTab
            href={getUrlWithUtmQueryString(encodeURI(`${baseRealEstateUrl}${AppList.scheduleTour.url}?listingaddressfortour=${props.address}&purchasePrice=${props.price}`))}
          />
        }
      </div>
      <div className="w-100 px-4">
        <Button
          variant="filled"
          label="Get Pre-approved"
          icon="far fa-check"
          className="w-100 fw-bold mt-3"
          size="lg"
          resetText
          newTab
          href={`${props.applyNowUrl}`}
        />
      </div>
      <div className="w-100 px-4">
        <Button
          variant="filled"
          label="Estimate Monthly Payments"
          icon="far fa-dollar-sign"
          className="w-100 fw-bold mt-3"
          size="lg"
          resetText
          newTab
          href={`${props.calculatorUrl}`}
        />
      </div>
    </div>
  </div>
	);
};


const SellCallsToAction = (props: { address: string, applyNowUrl: string, price: number}) => {
	const userOnMobile = useRecoilValue(AppState.gsIsMobile);

	return userOnMobile ? (
		<>
			<div className="d-flex w-100 py-1">
				<div className="px-1" style={{ width: '49%' }}>
					<Button
						bold
						fullWidth
						resetText
						noDecoration
						icon="fas fa-book"
						label="Request a Listing Agent"
						href={getUrlWithUtmQueryString(`${AppList.requestListingAgent.url}?leadAddress=${props.address}`)}
						newTab
						size="lg"
						className="w-100 fw-bold mt-1"
					/>
				</div>
				<div className="px-1" style={{ width: '49%' }}>
					{/* */}
					<Button
						bold
						fullWidth
						resetText
						noDecoration
						icon="fas fa-coins"
						label="Find My Home Estimate"
						href={getUrlWithUtmQueryString(`${AppList.homeValuation.url}?location=${props.address}`)}
						newTab
						size="lg"
						className="w-100 fw-bold mt-1"
					/>
				</div>
			</div>
		</>
	) : (
		<div className="position-relative shadow border-radius mt-4 cc-bg--white-100 w-100 pb-3 pt-2 h-100">
			<div className="w-100 px-4 position-sticky">
				<div className="col-12 col-sm-6 col-lg-12 pe-0 pe-sm-1 pe-lg-0">
					<Button
						bold
						fullWidth
						resetText
						noDecoration
						icon="fas fa-book"
						label="Request a Listing Agent"
						href={getUrlWithUtmQueryString(`${AppList.requestListingAgent.url}?leadAddress=${props.address}`)}
						newTab
						size="lg"
						className="w-100 fw-bold mt-3"					/>
				</div>
				<div className="col-12 col-sm-6 col-lg-12 ps-0 ps-sm-1 ps-lg-0">
					<Button
						bold
						fullWidth
						resetText
						noDecoration
						icon="fas fa-coins"
						label="Find My Home Estimate"
						href={getUrlWithUtmQueryString(`${AppList.homeValuation.url}?location=${props.address}`)}
						newTab
						size="lg"
						className="w-100 fw-bold mt-3"					/>
				</div>
				<div className="col-12 col-sm-6 col-lg-12 ps-0 ps-sm-1 ps-lg-0">
					<Button
						variant="filled"
						label="Get Pre-approved"
						icon="far fa-check"
						className="w-100 fw-bold mt-3"
						size="lg"
						resetText
						newTab
						href={`${props.applyNowUrl}`}
					/>
				</div>


			</div>
		</div>
	);
};


export default CallsToActionHighlight;
